// @flow
import initialStore from '../initialStore';
import { AuthStore } from '../../types/auth';
import { AuthAction } from '../../types/actions';

function providerStatusReducer(currentState: AuthStore, action: AuthAction) {
  switch (action.type) {
  case 'PROVIDER_STATUS_REQUEST':
    return Object.assign({}, currentState, {
      loading: true,
      data: [],
      error: null
    });
  case 'PROVIDER_STATUS_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      data: action.status
    });
  case 'PROVIDER_STATUS_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  default:
    return currentState || initialStore.status;
  }
}

function providerStatusesReducer(currentState: AuthStore, action: AuthAction) {
  switch (action.type) {
  case 'ALL_PROVIDER_STATUSES_REQUEST':
    return Object.assign({}, currentState, {
      loading: true,
      data: [],
      error: null
    });
  case 'ALL_PROVIDER_STATUSES_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      data: action.allStatuses
    });
  case 'ALL_PROVIDER_STATUSES_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  default:
    return currentState || initialStore.allStatuses;
  }
}

export {
  providerStatusReducer,
  providerStatusesReducer
};



// WEBPACK FOOTER //
// ./src/store/reducers/status.js